export default defineNuxtPlugin(nuxtApp => {
  // TODO check if we can use the feature flag in posthog
  const config = useRuntimeConfig()

  const isAlpha = config.public.name === 'alpha'
  const isBeta = config.public.name === 'beta'
  const isApp = config.public.name === 'app'

  const features = {
    tableAdvancedSetting: isAlpha || isBeta || isApp,
    scrollable: isAlpha,
    learn: isAlpha || isBeta,
    qc: isBeta || isApp,
    trainingRuns: isAlpha,
    comments: isAlpha || isBeta,
    pageMetadata: isAlpha || isBeta || isApp,
    posthogTesting: isAlpha,
    showDocStatus: isAlpha || isBeta,
    showDocStatusInTable: isAlpha,
    dan: isAlpha || isBeta,
    hermesTest: isAlpha || isBeta,
    notifications: isAlpha || isBeta,
    publishModel: isAlpha || isBeta || isApp,
    cancelSubscriptions: isAlpha || isBeta,
    dataSets: isAlpha,
    siteAnalytics: isAlpha || isBeta,
    sitesExplorePageRevamp: isAlpha || isBeta || isApp,
    tableUX: isAlpha || isBeta,
    virtualKeyboardSettings: isAlpha || isBeta || isApp,
    newSidebar: isAlpha || isBeta,
    sitesExploreTimeline: isAlpha || isBeta,
    deskMenuSplit: isAlpha || isBeta || isApp,
    sitesInformation: isAlpha || isBeta || isApp,
    updatedQTR: isAlpha || isBeta,
    createSample: isAlpha || isBeta || isApp,
    computeCER: isAlpha || isBeta || isApp,
    sitesCollecionFilter: isAlpha || isBeta,
    sitesSearchInDocument: isAlpha || isBeta || isApp,
    pageTranslate: isAlpha,
    batchSummarize: isAlpha,
    structureTagAttributes: isAlpha || isBeta || isApp,
    sitesAddLangToUrl: isAlpha || isBeta || isApp,
    uploadSortModal: isAlpha || isBeta || isApp,
    highlightSearchTerms: isAlpha || isBeta || isApp,
    sitesFilterMultiSelect: isAlpha || isBeta || isApp,
    improveTabUX: isAlpha,
    paymentFailedBanner: isAlpha || isBeta || isApp,
    sitesSearchMode: isAlpha || isBeta || isApp,
    structureTable: isAlpha,
    sitesWorldMap: isAlpha,
    debug: isAlpha,
    advancedRegionSort: isAlpha || isBeta,
  }
  return {
    provide: {
      features,
    },
  }
})
